import React from 'react';
import { bonuses } from '../data/bonuses';
import { BookCover } from './BookCover';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-22" data-mp="pio8yn0kl492">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-23" data-mp="avl8q8kv4hi1">
        <div className="text-center" data-id="element-24" data-mp="at8v27m50tas">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-25" data-mp="fteh989n1nlh">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-26" data-mp="1whrla59ac66">
            Five instant-use <span className="text-gold" data-id="element-27" data-mp="3o2wsxj8lq7nr">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-28" data-mp="3t06euows816u">
            The volumes give you the practices. These five make the season
            easy to run — what to do first, what to fix, what to say and what to
            pack.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-29" data-mp="1r6z13jwthrn2">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-30" data-mp="3ic3hs4imesd8" data-mpi={i}>
              {bonus.cover ? <div className="flex h-[260px] items-center justify-center overflow-hidden border-b border-navy-line bg-navy-deep sm:h-[320px]" data-id="element-31" data-mp="2zgdemdyybpxr">
                  <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-full w-full object-cover object-center" data-id="element-32" data-mp="38g8vmzf6uf5p" />
                </div> : <div className="flex h-[250px] items-center justify-center border-b border-navy-line bg-gradient-to-b from-navy-mid to-navy-deep sm:h-[300px]" data-id="element-33" data-mp="iq560wli15ba">
                  <BookCover kicker={`Bonus ${bonus.number}`} title={bonus.short} accent={bonus.accent} className="h-[82%] w-auto -rotate-2" data-id="element-34" data-mp="3hhr7nkziew03" />
                </div>}
              <div className="px-5 pb-6 pt-4" data-id="element-35" data-mp="3qgblo8u4khhz">
                <div className="flex flex-wrap items-center gap-2" data-id="element-36" data-mp="2ttgdf0objuks">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-37" data-mp="2xtqup9hka7ey">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-turf px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-white" data-id="element-38" data-mp="32r0g8e1txyxi">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-bold uppercase leading-tight text-white" data-id="element-39" data-mp="2a2d355r8ifv1">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-40" data-mp="27iyhx8b4csnc">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}